import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense, useMemo } from 'react';
import { TokenSource } from 'livekit-client';
import { domAnimation, LazyMotion } from 'motion/react';
import { asHexColor } from './embed-config';
import { mintConnectionDetails } from './use-embed-connection-details';
// Lazy-load the whole block (not just the popup panel): AgentPopup_01
// pulls in agents-ui's chat/transcript/visualizer payload with no internal
// code-split, and this widget ships to every visitor of every page that
// embeds it. Mounting it unconditionally still starts the chunk fetch
// immediately on load, trading "trigger bubble appears instantly" for
// "the synchronous bundle stays small".
const AgentPopup_01 = lazy(() => import('@repo/agents-ui').then((mod) => ({ default: mod.AgentPopup_01 })));
export function AgentClient({ apiBase, agentId, config }) {
    const tokenSource = useMemo(() => TokenSource.custom(async () => {
        const details = await mintConnectionDetails(apiBase, agentId, config.perSession);
        return {
            serverUrl: details.serverUrl,
            participantToken: details.participantToken,
        };
    }), [apiBase, agentId, config.perSession]);
    const color = asHexColor(config.color);
    return (_jsx(LazyMotion, { features: domAnimation, children: _jsx(Suspense, { fallback: null, children: _jsx(AgentPopup_01, { tokenSource: tokenSource, triggerColor: color, agentName: config.agentName, logo: config.logo || undefined, preConnectMessage: config.listeningText, audioVisualizer: { type: 'bar', size: 'lg', color }, controls: {
                    leave: false,
                    microphone: true,
                    chat: config.supportsChat,
                    camera: config.supportsVideo,
                    screenShare: config.supportsScreenshare,
                } }) }) }));
}
